import * as types from '../mutation-types'

const state = {
  // Lendo os produtos selecionados de string para JSON de localStorage
  main: [],
  produtoSelecionadoIndex: null
}

const mutations = {
  [types.ATUALIZAR_PRODUTO_ATIVO] (state, produto) {
    /**
       * Atualiza O produto selecionado e salva como string em localStorage
       */
     state.main = produto;
     
    //  localStorage.setItem('produtoAtivo', JSON.stringify(produto));
  },
  [types.EDITAR_PRODUTO_CARRINHO] (state, item) {
    /**
       * Atualiza O produto selecionado e salva como string em localStorage
       */
      state.produtoSelecionadoIndex = item;
    //  localStorage.setItem('produtoAtivo', JSON.stringify(produto));
  },
  [types.REMOVER_PRODUTO_ATIVO] (state) {
    /**
       * Limpa O produto selecionados
       */
     state.main = [];
    //  localStorage.removeItem('produtoAtivo');
  },

}

export default {
  state,
  mutations
}

